/**
 * Handles diffuse light shader functions code.
 */
export namespace HsShaderLightFunctionsCode {
  export const DIFFUSE_LIGHT_SHADER_FUNCTIONS_CODE: string = `
    vec3 addDirectionalLight(vec4 color, vec3 direction, vec3 normal) {
      float diffuse = max(0.0, dot(normal, direction));
      return diffuse * color.rgb * color.a;
    }

    vec3 addPointLight(vec4 color, vec3 point, float radius, float falloff, vec3 position, vec3 normal) {
      vec3 positionDifference = position - point;
      float intensity = 1.0 - clamp(length(positionDifference) / radius, 0.0, 1.0);
      intensity = pow(intensity, falloff);
      vec3 direction = normalize(positionDifference);
      float diffuse = max(0.0, dot(normal, direction));
      return diffuse * color.rgb * color.a * intensity;
    }

    vec3 addSpotLight(vec4 color, vec3 point, float angle, vec3 position, vec3 direction, vec3 normal) {
      vec3 target = normalize(position - point);
      float diffuse = max(0.0, dot(direction, target) - 1.0 + angle);
      diffuse *= dot(normal, direction) + 1.0;
      diffuse *= max(0.0, dot(normal, target));
      return diffuse * color.rgb * color.a;
    }
  `;

  export const SPECULAR_LIGHT_SHADER_FUNCTIONS_CODE: string = `
    vec3 addDirectionalLight(vec4 color, vec3 direction, vec3 normal, vec3 intersectionDirection) {
      float specular = max(0.0, dot(reflect(intersectionDirection, normal), direction));
      specular = pow(specular, smoothness) * smoothness / 64.0;
      return specular * color.rgb * color.a;
    }

    vec3 addPointLight(vec4 color, vec3 point, float radius, float falloff, vec3 position, vec3 normal, vec3 intersectionDirection) {
      vec3 positionDifference = position - point;
      float intensity = 1.0 - clamp(length(positionDifference) / radius, 0.0, 1.0);
      intensity = pow(intensity, falloff);
      vec3 direction = normalize(positionDifference);
      float specular = max(0.0, dot(normal, direction));
      return specular * color.rgb * color.a * intensity;
    }

    vec3 addSpotLight(vec4 color, vec3 point, float angle, vec3 position, vec3 direction, vec3 normal, vec3 intersectionDirection) {
      vec3 target = normalize(position - point);
      float specular = max(0.0, dot(direction, target) - 1.0 + angle);
      specular *= dot(normal, direction) + 1.0;
      specular *= max(0.0, dot(normal, target));
      return specular * color.rgb * color.a;
    }
  `;
}
